import { AvailabilityPage } from '@features/preferences/components/AvailabilityPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/availability')({ component: AvailabilityPage });
